(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-vip-club-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-mq-vip]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const endpoint = root.dataset.endpoint?.trim();
      const orderNumber = (root.dataset.whatsappNumber || '').replace(/\D/g, '');
      const gate = root.querySelector('[data-gate]');
      const portal = root.querySelector('[data-portal]');
      const form = root.querySelector('[data-login-form]');
      const passphraseInput = root.querySelector('[data-passphrase]');
      const showPasswordButton = root.querySelector('[data-show-password]');
      const unlockButton = root.querySelector('[data-unlock-button]');
      const unlockLabel = root.querySelector('[data-unlock-label]');
      const unlockSpinner = root.querySelector('[data-unlock-spinner]');
      const loginMessage = root.querySelector('[data-login-message]');
      const activeOfferTeaser = root.querySelector('[data-active-offer-teaser]');
      const activeOfferCount = root.querySelector('[data-active-offer-count]');
      const activeOfferLabel = root.querySelector('[data-active-offer-label]');
      const portalMessage = root.querySelector('[data-portal-message]');
      const loading = root.querySelector('[data-loading]');
      const panels = root.querySelector('[data-panels]');
      const videoDialog = root.querySelector('[data-video-dialog]');
      const videoDialogTitle = root.querySelector('[data-video-dialog-title]');
      const videoPlayer = root.querySelector('[data-video-player]');
      const videoClose = root.querySelector('[data-video-close]');
      const storageKey = root.dataset.sessionKey || 'mq-vip-session';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let cardSequence = 0;

      const copy = {
        welcome: root.dataset.copyWelcome,
        wrongPassphrase: root.dataset.copyWrongPassphrase,
        sessionExpired: root.dataset.copySessionExpired,
        unavailable: root.dataset.copyUnavailable,
        notConfigured: root.dataset.copyNotConfigured,
        retail: root.dataset.copyRetail,
        wholesale: root.dataset.copyWholesale,
        vipPrice: root.dataset.copyVipPrice,
        savings: root.dataset.copySavings,
        watchVideo: root.dataset.copyWatchVideo,
        openPdf: root.dataset.copyOpenPdf,
        videoAvailable: root.dataset.copyVideoAvailable,
        closeVideo: root.dataset.copyCloseVideo,
        pages: root.dataset.copyPages,
        validFrom: root.dataset.copyValidFrom,
        validUntil: root.dataset.copyValidUntil,
        duration: root.dataset.copyDuration,
        newBadge: root.dataset.copyNewBadge,
        onlinePayment: root.dataset.copyOnlinePayment,
        onlineHelp: root.dataset.copyOnlineHelp,
        cod: root.dataset.copyCod,
        codHelp: root.dataset.copyCodHelp,
        codMessage: root.dataset.copyCodMessage,
        free: root.dataset.copyFree,
        freeDelivery: root.dataset.copyFreeDelivery,
        deliveryFee: root.dataset.copyDeliveryFee,
        total: root.dataset.copyTotal,
        totalPayable: root.dataset.copyTotalPayable,
        vipPlusDelivery: root.dataset.copyVipPlusDelivery,
        chooseDelivery: root.dataset.copyChooseDelivery,
        orderNow: root.dataset.copyOrderNow,
        offerEnded: root.dataset.copyOfferEnded,
        mediaPlaceholder: root.dataset.copyMediaPlaceholder,
        videoLabel: root.dataset.copyVideoLabel,
        noNew: root.dataset.copyNoNew,
        noActive: root.dataset.copyNoActive,
        noExpired: root.dataset.copyNoExpired,
        offerSingular: root.dataset.copyOfferSingular,
        offerPlural: root.dataset.copyOfferPlural,
        showPassphrase: root.dataset.copyShowPassphrase,
        hidePassphrase: root.dataset.copyHidePassphrase,
        orderMessage: root.dataset.copyOrderMessage,
        orderTotal: root.dataset.copyOrderTotal,
      };

      const storage = {
        get() {
          try { return window.sessionStorage.getItem(storageKey); } catch { return null; }
        },
        set(value) {
          try { window.sessionStorage.setItem(storageKey, value); } catch { return; }
        },
        remove() {
          try { window.sessionStorage.removeItem(storageKey); } catch { return; }
        },
      };

      const element = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined && text !== null) node.textContent = String(text);
        return node;
      };

      const svgIcon = (viewBox, paths) => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', viewBox);
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '1.8');
        svg.setAttribute('aria-hidden', 'true');
        paths.forEach((definition) => {
          const path = document.createElementNS('http://www.w3.org/2000/svg', definition.tag || 'path');
          Object.entries(definition).forEach(([key, value]) => {
            if (key !== 'tag') path.setAttribute(key, value);
          });
          svg.append(path);
        });
        return svg;
      };

      const setMessage = (node, message, tone = 'error') => {
        node.textContent = message || '';
        node.dataset.tone = tone;
      };

      const setUnlocking = (isLoading) => {
        unlockButton.disabled = isLoading;
        unlockSpinner.hidden = !isLoading;
        unlockLabel.style.opacity = isLoading ? '0.82' : '1';
      };

      const isSafeUrl = (value) => {
        if (typeof value !== 'string' || !value) return false;
        try { return new URL(value).protocol === 'https:'; } catch { return false; }
      };

      const api = async (body) => {
        if (!isSafeUrl(endpoint)) throw new Error('not-configured');
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          redirect: 'error',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        let data = {};
        try { data = await response.json(); } catch { data = {}; }
        if (!response.ok) {
          const error = new Error(data.error || 'request-failed');
          error.status = response.status;
          throw error;
        }
        return data;
      };

      const amount = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
      };

      const money = (value) => {
        const number = amount(value);
        if (number === null) return '—';
        return `Rs ${new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 }).format(number)}`;
      };

      const displayDate = (value) => {
        if (!value) return '';
        const date = new Date(`${value}T00:00:00`);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('en-PK', { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
      };

      const countLabel = (count) => `${count} ${count === 1 ? copy.offerSingular : copy.offerPlural}`;

      const loadActiveOfferTeaser = async () => {
        try {
          const data = await api({ action: 'count' });
          const count = Number(data.activeCount);
          if (!Number.isInteger(count) || count < 0) throw new Error('invalid-count');
          activeOfferCount.textContent = String(count);
          activeOfferCount.removeAttribute('aria-hidden');
          activeOfferLabel.textContent = count === 1
            ? 'VIP offer live now'
            : 'VIP offers live now';
        } catch {
          activeOfferTeaser.hidden = true;
        }
      };

      const closeVideoDialog = () => {
        videoPlayer.pause();
        videoPlayer.removeAttribute('src');
        videoPlayer.load();
        if (videoDialog.open) videoDialog.close();
      };

      const openVideoDialog = (offer) => {
        if (!isSafeUrl(offer.video_url)) return;
        if (typeof videoDialog.showModal !== 'function') {
          window.open(offer.video_url, '_blank', 'noopener,noreferrer');
          return;
        }
        videoDialogTitle.textContent = offer.title || copy.videoLabel;
        videoPlayer.src = offer.video_url;
        if (isSafeUrl(offer.image_url)) videoPlayer.poster = offer.image_url;
        else videoPlayer.removeAttribute('poster');
        videoDialog.showModal();
        videoPlayer.play().catch(() => {});
      };

      const createMedia = (offer, showNewBadge) => {
        const media = element('div', 'mq-vip__media');
        const hasImage = isSafeUrl(offer.image_url);
        const hasVideo = isSafeUrl(offer.video_url);
        const hasPdf = isSafeUrl(offer.pdf_url);
        if (hasImage) {
          const image = document.createElement('img');
          image.src = offer.image_url;
          image.alt = offer.title || '';
          image.loading = 'lazy';
          image.decoding = 'async';
          media.append(image);
        } else {
          const placeholder = element('div', 'mq-vip__media-placeholder');
          placeholder.append(
            hasVideo
              ? svgIcon('0 0 64 64', [
                { tag: 'circle', cx: '32', cy: '32', r: '24' },
                { d: 'm27 22 16 10-16 10V22Z' },
              ])
              : svgIcon('0 0 64 64', [
                { d: 'M13 12h28a8 8 0 0 1 8 8v32H21a8 8 0 0 1-8-8V12Z' },
                { d: 'M21 12v40M30 23h11M30 31h11' },
              ]),
            element('span', '', hasVideo ? copy.videoAvailable : copy.mediaPlaceholder),
          );
          media.append(placeholder);
        }
        if (showNewBadge) media.append(element('span', 'mq-vip__media-badge', copy.newBadge));

        if (hasVideo || hasPdf) {
          const actions = element('div', 'mq-vip__media-actions');
          if (hasVideo) {
            const watch = element('button', 'mq-vip__media-action', copy.watchVideo);
            watch.type = 'button';
            watch.prepend(svgIcon('0 0 24 24', [
              { tag: 'circle', cx: '12', cy: '12', r: '9' },
              { d: 'm10 8 6 4-6 4V8Z' },
            ]));
            watch.addEventListener('click', () => openVideoDialog(offer));
            actions.append(watch);
          }
          if (hasPdf) {
            const pdf = element('a', 'mq-vip__media-action', copy.openPdf);
            pdf.href = offer.pdf_url;
            pdf.target = '_blank';
            pdf.rel = 'noopener noreferrer';
            pdf.prepend(svgIcon('0 0 24 24', [
              { d: 'M14 5h5v5' },
              { d: 'm10 14 9-9' },
              { d: 'M19 13v6H5V5h6' },
            ]));
            actions.append(pdf);
          }
          media.append(actions);
        }
        return media;
      };

      const createDuration = (offer) => {
        const startsOn = displayDate(offer.starts_on);
        const endsOn = displayDate(offer.ends_on);
        if (!startsOn && !endsOn) return null;
        let label = '';
        if (startsOn && endsOn) label = `${copy.duration}: ${startsOn} – ${endsOn}`;
        else if (startsOn) label = `${copy.validFrom}: ${startsOn}`;
        else label = `${copy.validUntil}: ${endsOn}`;
        const row = element('div', 'mq-vip__duration');
        row.append(
          svgIcon('0 0 24 24', [
            { tag: 'circle', cx: '12', cy: '12', r: '9' },
            { d: 'M12 7v5l3 2' },
          ]),
          element('span', '', label),
        );
        return row;
      };

      const createPrices = (offer) => {
        const prices = element('div', 'mq-vip__prices');
        const references = element('div', 'mq-vip__reference-prices');
        const wholesaleAvailable = offer.wholesale_price !== null && offer.wholesale_price !== undefined && offer.wholesale_price !== '';
        if (!wholesaleAvailable) references.classList.add('mq-vip__reference-prices--single');

        const addReference = (label, value) => {
          const item = element('div', 'mq-vip__reference-price');
          item.append(element('span', '', label), element('del', '', money(value)));
          references.append(item);
        };

        addReference(copy.retail, offer.retail_price);
        if (wholesaleAvailable) addReference(copy.wholesale, offer.wholesale_price);

        const vip = element('div', 'mq-vip__vip-price');
        const vipText = element('div');
        vipText.append(element('span', '', copy.vipPrice), element('strong', '', money(offer.vip_price)));
        vip.append(vipText);
        const retail = amount(offer.retail_price);
        const vipAmount = amount(offer.vip_price);
        if (retail !== null && vipAmount !== null && retail > vipAmount) {
          vip.append(element('small', 'mq-vip__savings', `${copy.savings} ${money(retail - vipAmount)}`));
        }
        prices.append(references, vip);
        return prices;
      };

      const orderUrl = (offer, payment, total) => {
        if (!orderNumber) return '';
        const firstLine = copy.orderMessage
          .replace('__BOOK__', offer.title || '')
          .replace('__PAYMENT__', payment);
        const totalLine = copy.orderTotal.replace('__TOTAL__', money(total));
        return `https://wa.me/${orderNumber}?text=${encodeURIComponent(`${firstLine}\n\n${totalLine}`)}`;
      };

      const createOrderPanel = (offer) => {
        const methods = [];
        if (offer.online_payment_available === true) {
          methods.push({
            key: 'online',
            label: copy.onlinePayment,
            help: copy.onlineHelp,
            message: copy.onlinePayment,
            fee: amount(offer.online_delivery_fee) || 0,
          });
        }
        if (offer.cod_available === true) {
          methods.push({
            key: 'cod',
            label: copy.cod,
            help: copy.codHelp,
            message: copy.codMessage,
            fee: amount(offer.cod_delivery_fee) || 0,
          });
        }
        if (!methods.length) return null;

        cardSequence += 1;
        const panel = element('div', 'mq-vip__order-panel');
        const choices = element('fieldset', 'mq-vip__delivery-choices');
        choices.append(element('legend', 'mq-vip__sr-only', copy.chooseDelivery));
        const name = `mq-vip-delivery-${cardSequence}`;
        const optionRows = [];

        methods.forEach((method, index) => {
          const choice = element('label', `mq-vip__delivery-choice${index === 0 ? ' mq-vip__delivery-choice--selected' : ''}`);
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = name;
          input.value = method.key;
          input.checked = index === 0;
          const radio = element('span', 'mq-vip__radio-mark');
          radio.setAttribute('aria-hidden', 'true');
          const text = element('span', 'mq-vip__delivery-name');
          text.append(element('strong', '', method.label), element('span', '', method.help));
          const fee = element('span', 'mq-vip__delivery-fee', method.fee === 0 ? copy.free : `+ ${money(method.fee)}`);
          choice.append(input, radio, text, fee);
          choices.append(choice);
          optionRows.push({ choice, input, method });
        });

        const payable = element('div', 'mq-vip__payable');
        const payableCopy = element('div');
        const payableBreakdown = element('small');
        payableCopy.append(element('span', '', copy.totalPayable), payableBreakdown);
        const payableTotal = element('strong');
        payable.append(payableCopy, payableTotal);

        const orderButton = element('a', 'mq-vip__order-button', copy.orderNow);
        orderButton.target = '_blank';
        orderButton.rel = 'noopener noreferrer';

        const updateOrder = (method) => {
          optionRows.forEach((row) => row.choice.classList.toggle('mq-vip__delivery-choice--selected', row.method.key === method.key));
          const vipAmount = amount(offer.vip_price) || 0;
          const total = vipAmount + method.fee;
          const deliveryLabel = method.fee === 0 ? copy.freeDelivery : `${money(method.fee)} ${copy.deliveryFee}`;
          payableBreakdown.textContent = copy.vipPlusDelivery.replace('__DELIVERY__', deliveryLabel);
          payableTotal.textContent = money(total);
          orderButton.href = orderUrl(offer, method.message, total);
        };

        optionRows.forEach((row) => {
          row.input.addEventListener('change', () => {
            if (row.input.checked) updateOrder(row.method);
          });
        });
        updateOrder(methods[0]);
        panel.append(choices, payable);
        if (orderNumber) panel.append(orderButton);
        return panel;
      };

      const createCard = (offer, panelKey) => {
        const expired = offer.status === 'expired';
        const card = element('article', `mq-vip__card${expired ? ' mq-vip__card--expired' : ''}`);
        const content = element('div', 'mq-vip__content');
        if (offer.eyebrow) content.append(element('p', 'mq-vip__tagline', offer.eyebrow));
        content.append(element('h3', '', offer.title || ''));

        const meta = element('div', 'mq-vip__book-meta');
        if (offer.writer) meta.append(element('span', '', offer.writer));
        if (amount(offer.page_count) !== null) meta.append(element('span', '', `${offer.page_count} ${copy.pages}`));
        if (meta.childElementCount) content.append(meta);

        const features = ['bullet_1', 'bullet_2', 'bullet_3']
          .map((key) => typeof offer[key] === 'string' ? offer[key].trim() : '')
          .filter(Boolean);
        if (features.length) {
          const list = element('ul', 'mq-vip__features');
          features.forEach((feature) => list.append(element('li', '', feature)));
          content.append(list);
        }

        const duration = createDuration(offer);
        if (duration) content.append(duration);
        content.append(createPrices(offer));

        if (expired) {
          content.append(element('p', 'mq-vip__ended', copy.offerEnded));
        } else {
          const orderPanel = createOrderPanel(offer);
          if (orderPanel) content.append(orderPanel);
        }

        card.append(createMedia(offer, panelKey === 'new'), content);
        return card;
      };

      const renderCollection = (key, offers, emptyMessage) => {
        const grid = root.querySelector(`[data-grid="${key}"]`);
        const sectionCount = root.querySelector(`[data-section-count="${key}"]`);
        const tabCount = root.querySelector(`[data-count-${key}]`);
        grid.replaceChildren();
        tabCount.textContent = String(offers.length);
        sectionCount.textContent = countLabel(offers.length);
        if (!offers.length) {
          grid.append(element('p', 'mq-vip__empty', emptyMessage));
          return;
        }
        const fragment = document.createDocumentFragment();
        offers.forEach((offer) => fragment.append(createCard(offer, key)));
        grid.append(fragment);
      };

      const renderOffers = (offers) => {
        const safeOffers = Array.isArray(offers) ? offers : [];
        const active = safeOffers.filter((offer) => offer.status === 'active');
        const fresh = active.filter((offer) => offer.is_new === true);
        const expired = safeOffers.filter((offer) => offer.status === 'expired');
        renderCollection('new', fresh, copy.noNew);
        renderCollection('active', active, copy.noActive);
        renderCollection('expired', expired, copy.noExpired);
      };

      const selectTab = (key, focus = false) => {
        root.querySelectorAll('[data-tab]').forEach((tab) => {
          const selected = tab.dataset.tab === key;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        root.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== key;
        });
      };

      const transitionToTab = (key, focus = false) => {
        if (document.startViewTransition && !reducedMotion.matches) {
          document.startViewTransition(() => selectTab(key, focus));
        } else {
          selectTab(key, focus);
        }
      };

      const showGate = (message = '') => {
        portal.hidden = true;
        gate.hidden = false;
        loading.hidden = true;
        panels.hidden = false;
        setMessage(loginMessage, message);
        window.setTimeout(() => passphraseInput.focus(), 50);
      };

      const showPortal = () => {
        gate.hidden = true;
        portal.hidden = false;
        setMessage(loginMessage, '');
      };

      const loadOffers = async (token, announce = false) => {
        showPortal();
        loading.hidden = false;
        panels.hidden = true;
        setMessage(portalMessage, announce ? copy.welcome : '', 'success');
        try {
          const data = await api({ action: 'offers', token });
          renderOffers(data.offers);
          loading.hidden = true;
          panels.hidden = false;
          selectTab('new');
        } catch (error) {
          loading.hidden = true;
          if (error.status === 401) {
            storage.remove();
            showGate(copy.sessionExpired);
            return;
          }
          panels.hidden = false;
          setMessage(portalMessage, error.message === 'not-configured' ? copy.notConfigured : copy.unavailable);
        }
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        setMessage(loginMessage, '');
        if (!passphraseInput.value) {
          setMessage(loginMessage, copy.wrongPassphrase);
          passphraseInput.focus();
          return;
        }
        setUnlocking(true);
        try {
          const data = await api({ action: 'unlock', passphrase: passphraseInput.value });
          storage.set(data.token);
          passphraseInput.value = '';
          await loadOffers(data.token, true);
        } catch (error) {
          const message = error.message === 'not-configured'
            ? copy.notConfigured
            : error.status === 401
              ? copy.wrongPassphrase
              : copy.unavailable;
          setMessage(loginMessage, message);
        } finally {
          setUnlocking(false);
        }
      });

      showPasswordButton.addEventListener('click', () => {
        const revealing = passphraseInput.type === 'password';
        passphraseInput.type = revealing ? 'text' : 'password';
        showPasswordButton.setAttribute('aria-pressed', String(revealing));
        showPasswordButton.setAttribute('aria-label', revealing ? copy.hidePassphrase : copy.showPassphrase);
        passphraseInput.focus();
      });

      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => transitionToTab(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          transitionToTab(tabs[nextIndex].dataset.tab, true);
        });
      });

      videoClose.setAttribute('aria-label', copy.closeVideo);
      videoClose.addEventListener('click', closeVideoDialog);
      videoDialog.addEventListener('click', (event) => {
        if (event.target === videoDialog) closeVideoDialog();
      });
      videoDialog.addEventListener('close', () => {
        videoPlayer.pause();
        videoPlayer.removeAttribute('src');
        videoPlayer.load();
      });

      const token = storage.get();
      if (token) loadOffers(token);
      else {
        showGate('');
        loadActiveOfferTeaser();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
